import { getInstance } from "../auth/index";

const authService = getInstance();

function get_permissions_func() {
  let userauth =
    authService.user["https://app.oceanbolt.com/user_authorization"] || {};
  return userauth.permissions;
}

const sidebarChildren = [
  {
    _name: "CSidebarNavItem",
    name: "Platform Home",
    to: "/home",
    // icons are here: src/assets/icons/icons.js
    icon: "cil-home"
  },

  {
    _name: "CSidebarNavItem",
    name: "Oceanbolt Wiki",
    target: "_blank",
    // use href attribute to specify an external url
    href: "https://wiki.oceanbolt.com",
    // icons are here: src/assets/icons/icons.js
    icon: "cil-globe-alt"
  },

  {
    _name: "CSidebarNavItem",
    name: "Methodology",
    to: "/methodology",
    // icons are here: src/assets/icons/icons.js
    icon: "cil-school"
  },

  // trade flows section
  {
    _name: "CSidebarNavTitle",
    _children: ["Trade flows"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Global Trade Flows",
    to: "/tradeflows",
    icon: "cil-globe-alt"
  },
  {
    _name: "CSidebarNavItem",
    name: "Port Flows",
    to: "/port-tradeflows",
    icon: "cil-swap-horizontal"
  },
  {
    _name: "CSidebarNavItem",
    name: "Trade lane analysis",
    to: "/ports-comparison",
    icon: "cil-swap-horizontal"
  },
  {
    _name: "CSidebarNavItem",
    name: "Port calls",
    to: "/port-calls",
    icon: "cil-swap-horizontal"
  },

  //Live section
  {
    _name: "CSidebarNavTitle",
    _children: ["Live view"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Live Stats",
    to: "/live-stats",
    icon: "cil-map",
    adminOnly: true
  },
  {
    _name: "CSidebarNavItem",
    name: "Live Map",
    to: "/live-map",
    icon: "cil-map",
    betaFlag: true
  },
  {
    _name: "CSidebarNavItem",
    name: "Vessel Details",
    to: "/vessel-details",
    icon: "cil-boat-alt"
  },

  // fleets section
  {
    _name: "CSidebarNavTitle",
    _children: ["Fleets"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Monitor",
    to: "/fleet-monitor",
    icon: "cil-grid"
  },

  {
    _name: "CSidebarNavItem",
    name: "Edit Fleets",
    to: "/edit-fleets",
    icon: "cil-columns"
  },

  // tonnage section
  {
    _name: "CSidebarNavTitle",
    _children: ["Tonnage"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Basin Balance",
    to: "/tonnage-basins",
    icon: "cil-globe-alt"
  },
  {
    _name: "CSidebarNavItem",
    name: "Zone Counts",
    to: "/tonnage-zones",
    icon: "cil-chart-line"
  },
  {
    _name: "CSidebarNavItem",
    name: "Fleet Speed",
    to: "/tonnage-speed",
    icon: "cil-speedometer"
  },
  {
    _name: "CSidebarNavItem",
    name: "Fleet Growth",
    to: "/fleet-growth",
    icon: "cil-chevron-double-up",
    adminOnly: true
  },

  // congestion section
  {
    _name: "CSidebarNavTitle",
    _children: ["Congestion"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Congestion (New)",
    to: "/congestion",
    icon: "cil-layers",
    //betaAccess: true,
    betaFlag: true
  },

  // dry dock section
  {
    _name: "CSidebarNavTitle",
    _children: ["Dry dock"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Dry Dock Monitor",
    to: "/drydock",
    icon: "cil-brush-alt"
  },
  {
    _name: "CSidebarNavItem",
    name: "Dry Dock Stats",
    to: "/drydock-summary",
    icon: "cil-chart"
    // badge: {
    //   color: 'primary',
    //   text: 'NEW'
    // },
  },

  // user section
  {
    _name: "CSidebarNavTitle",
    _children: ["User"]
  },
  {
    _name: "CSidebarNavItem",
    name: "Profile",
    to: "/profile",
    icon: "cil-user"
  }
];
/*
badge = {
      color: 'primary',
      text: 'Beta'
    }
    */
let childrenToShow = [];
for (let child of sidebarChildren) {
  if (child.betaFlag) {
    child.badge = {
      color: "primary",
      text: "Beta"
    };
  }

  if (checkPermissions(child)) {
    childrenToShow.push(child);
  }
}

let sidebar = [
  {
    _name: "CSidebarNav",
    _children: childrenToShow
  }
];

export default sidebar;

function checkPermissions(child) {
  if (child.adminOnly) {
    return get_permissions_func().includes("admin");
  }

  if (child.betaAccess) {
    return get_permissions_func().includes("access:beta");
  }

  return true;
}
